/**
 * Returns the Intuit modal context if the error is a 409 `processor_pending`
 * with `active_processor: "intuit"`, else returns null. Callers unmarshal the
 * axios error and open <IntuitCheckoutModal/> with the resulting ctx.
 */
export function intuitCtxFromCheckoutError(error, params) {
  const resp = error?.response;
  if (resp?.status !== 409) return null;
  const raw = resp.data || {};
  const detail = (raw._detail !== undefined && raw._detail !== null) ? raw._detail : raw.detail;
  const info = typeof detail === "object" ? detail : raw;
  if (!info?.processor_pending || info?.active_processor !== "intuit") return null;
  return {
    medication_id: params.medication_id,
    payment_type: params.payment_type || "one_time",
    order_id: params.order_id || null,
    resubmit_from_order_id: params.resubmit_from_order_id || null,
    coupon_id: params.coupon_id || null,
    amount: params.amount != null ? Number(params.amount) : null,
  };
}
